<template>
  <div>
    <Navbar></Navbar>
    <transition name="fade" mode="out-in">
    <router-view></router-view>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'home',
  components: {
    Navbar,

  },
  created(){
    this.$router.push('/OrderInfo')
  }
}
</script>
